// Thin GA4 wrapper. Every function is a safe no-op when
// REACT_APP_GA_MEASUREMENT_ID isn't set (local dev, or before the property
// exists) — nothing here should ever throw or block the app because
// analytics isn't configured yet.
const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

let initialized = false;

const isEnabled = () => Boolean(GA_MEASUREMENT_ID) && typeof window !== 'undefined';

// Loads gtag.js and initializes GA4. Call once, on app mount. Safe to call
// more than once — subsequent calls are no-ops.
export const initGA = () => {
  if (!isEnabled() || initialized) return;
  initialized = true;

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  }
  window.gtag = gtag;
  gtag('js', new Date());
  // send_page_view: false — App.jsx's route listener sends page_view
  // explicitly on every navigation instead, since GA4's automatic pageview
  // (fired once at script load) doesn't know about React Router's
  // client-side route changes.
  gtag('config', GA_MEASUREMENT_ID, { send_page_view: false });
};

export const trackPageview = (path) => {
  if (!isEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', 'page_view', { page_path: path });
};

// name: a GA4 event name (snake_case by convention, e.g. 'sign_up').
// params: arbitrary event parameters — keep these to non-sensitive,
// low-cardinality values (plan names, counts, platform keys), never emails,
// tokens, or other user-identifying/sensitive data.
export const trackEvent = (name, params = {}) => {
  if (!isEnabled() || typeof window.gtag !== 'function') return;
  window.gtag('event', name, params);
};
